import {
    PAYMENTBRANDLIST_SUCCESS,
    PAYMENTBRANDLIST_FAILED,
    RESET_PAYMENTBRANDLIST,
    LOADING_PAYMENTBRANDLIST,
    NETWORK_ERROR_PAYMENTBRANDLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_PAYMENTBRANDLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case PAYMENTBRANDLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case PAYMENTBRANDLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_PAYMENTBRANDLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_PAYMENTBRANDLIST:
            return (state = initialState);
        default:
            return state;
    }
};
